<template>
  <div class="main-box">
    <el-tabs v-model="tabIdx" @tab-click="chooseTab">
      <el-tab-pane label="通知会员" name="1"></el-tab-pane>
      <el-tab-pane label="通知商户" name="2"></el-tab-pane>
    </el-tabs>
    <div class="mg-bt-10">
      <el-button type="primary" size="small" icon="el-icon-refresh" @click="rsyncData(1)" v-if="tabIdx==1">同步小程序订阅消息</el-button>
      <el-button type="primary" size="small" icon="el-icon-s-tools" @click="showNotice()" v-if="tabIdx==2">设置通知地址</el-button>
    </div>
    <div class="notice-tip mg-bt-10" v-if="tabIdx==1">
      <div class="mg-bt-3 red"><i class="el-icon-warning-outline"></i> 注意：</div>
      <div>登录微信小程序后台 -> 基本设置 -> 服务类目：增加类目《生活服务 > 百货/超市/便利店》</div>
    </div>
    <el-table
        :data="tableData"
        ref="rfTable"
        size="mini">
      <el-table-column
          prop="title"
          label="消息类型"
          min-width="200">
      </el-table-column>
      <el-table-column v-if="tabIdx==2"
          prop="mail_status"
          label="站内信"
          align="left"
          width="200">
        <template slot-scope="scope">
          <div style="padding: 10px 0;">
          <el-switch :value="scope.row.mail_status==1" @change="changeStatus(scope.row.template_type, 1, scope.row.mail_status==1?0:1)" active-text="关闭" inactive-text="开启"></el-switch>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="tabIdx==2"
         prop="audio_status"
         label="语音"
         align="left"
         width="200">
        <template slot-scope="scope">
          <div style="padding: 10px 0;">
            <el-switch :value="scope.row.audio_status==1" @change="changeStatus(scope.row.template_type, 7, scope.row.audio_status==1?0:1)" active-text="关闭" inactive-text="开启"></el-switch>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="tabIdx==2"
           prop="dingding_status"
           label="钉钉"
           align="left"
           width="200">
        <template slot-scope="scope">
          <div style="padding: 10px 0;">
            <el-switch :value="scope.row.dingding_status==1" @change="changeStatus(scope.row.template_type, 4, scope.row.dingding_status==1?0:1)" active-text="关闭" inactive-text="开启"></el-switch>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="tabIdx==2"
           prop="feishu_status"
           label="飞书"
           align="left"
           width="200">
        <template slot-scope="scope">
          <div style="padding: 10px 0;">
            <el-switch :value="scope.row.feishu_status==1" @change="changeStatus(scope.row.template_type, 5, scope.row.feishu_status==1?0:1)" active-text="关闭" inactive-text="开启"></el-switch>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="tabIdx==2"
           prop="qw_status"
           label="企微"
           align="left"
           width="200">
        <template slot-scope="scope">
          <div style="padding: 10px 0;">
            <el-switch :value="scope.row.qw_status==1" @change="changeStatus(scope.row.template_type, 6, scope.row.qw_status==1?0:1)" active-text="关闭" inactive-text="开启"></el-switch>
          </div>
        </template>
      </el-table-column>
<!--      <el-table-column-->
<!--          prop="wechat_status"-->
<!--          label="公众号消息模板"-->
<!--          align="left"-->
<!--          width="200">-->
<!--        <template slot-scope="scope">-->
<!--          <el-switch :value="scope.row.wechat_status==1" @change="changeStatus(scope.row.template_type,2,scope.row.wechat_status==1?0:1)" active-text="关闭" inactive-text="开启"></el-switch>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column v-if="tabIdx==1"
          prop="applet_status"
          label="小程序订阅消息"
          align="left">
        <template slot-scope="scope">
          <div style="padding: 10px 0;">
            <el-switch :value="scope.row.applet_status==1" @change="changeStatus(scope.row.template_type,3,scope.row.applet_status==1?0:1)" active-text="关闭" inactive-text="开启"></el-switch>
            <span v-if="scope.row.applet_content" class="mg-lf-10">模板ID：{{scope.row.applet_content.tmpId}}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="设置通知地址" :visible.sync="dialogVisible" width="50%">
      <notice-set @call="dialogVisible=false"></notice-set>
    </el-dialog>
  </div>
</template>
<script>

import NoticeSet from "@/components/Config/NoticeSet";
export default {
  components: {
    NoticeSet
  },
  data() {
    return {
      source_domain: this.config.SOURCE_DOMAIN,
      tableData: [],
      tabIdx: '1',
      config: {},
      dialogVisible: false
    };
  },
  created() {
    this.getList();
  },
  mounted() {
  },
  computed: {},
  methods: {
    showNotice() {
      this.dialogVisible = true
    },
    chooseTab(e) {
      this.getList()
    },
    getList() {
      var that = this
      that.showLoading()
      var param = {
        source: this.tabIdx
      }
      this.$api.merchant.messageIndex(param, function (res) {
        that.hideLoading()
        if (res.errcode == 0) {
          that.tableData = res.data
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    changeStatus(type,ctype,status) {
      this.$api.merchant.messageShenhe({type: type,ctype:ctype, status: status}, res => {
        if (res.errcode == 0) {
          this.success(res.errmsg)
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    handleSearch() {
      this.getList()
    },
    rsyncData(type) {
      this.showLoading()
      this.$api.merchant.messageRsync({type:type}, res => {
        this.hideLoading()
        if(res.errcode==0) {
          this.success(res.errmsg)
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
    }
  }
};
</script>
<style scoped>
</style>
